export class Question {
    constructor(questionState) {
        this.questionState = questionState;
    }
    get id() {
        return this.questionState.id;
    }
    get alias() {
        return this.questionState.alias;
    }
    get name() {
        return this.questionState.name;
    }
    get imagen() {
        return this.questionState.imagen;
    }
    get info() {
        return this.questionState.info;
    }
    getState() {
        return this.questionState;
    }
}
